import React from 'react';
import {IdMirrorCard} from './id-mirror-card';
import {DarkC3Image, LightC3Image} from '../../../data/id-mirror-data';

const titleDark = 'Más cómodo que nunca';
const descriptionDark = (
  <>
    <b>Hecho para que conducir sea cada vez más fácil.</b>
    {/* Diseño digital más intuitivo y botones físicos para que estés en total sintonía con el Nuevo ID. Polo desde el primer momento. */}
  </>
);

const titleLight = 'Toque clásico por dentro';
const descriptionLight = (
  <>
    <b>
      El ID. Polo evoluciona sin olvidar de dónde viene, con detalles pensados
      para los más nostálgicos.
    </b>{' '}
    {/* Activa el Modo Retro y trae la esencia del Golf de los 80 al Digital Cockpit. */}
  </>
);

export const Card3 = ({
  isMobileCard = false,
  cardInfoDarkRef,
  cardInfoLightRef,
}: {
  isMobileCard?: boolean;
  cardInfoLightRef?: React.Ref<HTMLDivElement>;
  cardInfoDarkRef?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <IdMirrorCard
      titleLight={titleLight}
      descriptionLight={descriptionLight}
      imageLight={LightC3Image}
      titleDark={titleDark}
      descriptionDark={descriptionDark}
      imageDark={DarkC3Image}
      cardNumber={'3'}
      isMobileCard={isMobileCard}
      cardInfoDarkRef={cardInfoDarkRef}
      cardInfoLightRef={cardInfoLightRef}
    />
  );
};
